// Navigation that works both natively and inside the legacy iframe.
//
// japoniacars.pl still embeds the chrome-less routes (/iframe, /search) in an
// <iframe>. There, "search" and "open a car" have to navigate the *parent*
// WordPress page, exactly as before — routing inside the frame would render
// the whole site into an 800px box. On the native pages the same actions are
// ordinary in-app navigations.
//
// Once WordPress is retired and nothing embeds the app any more, the
// isEmbedded() branch can go.

const PARENT_SITE = 'https://japoniacars.pl'
const RESULTS_PATH = '/wyniki-wyszukiwania/'

export function isEmbedded() {
  try {
    return window.top !== window.self
  } catch (e) {
    // A cross-origin parent throws on access, which itself means we're framed.
    return true
  }
}

/** Drop empty values so the URL matches what the old code produced. */
function clean(query) {
  const out = {}
  for (const [key, value] of Object.entries(query || {})) {
    if (value != null && value !== '') out[key] = value
  }
  return out
}

/**
 * Go to the results page — in the parent document when framed, through the
 * router otherwise.
 */
export function goToResults(router, query) {
  const params = clean(query)
  if (isEmbedded()) {
    const qs = new URLSearchParams(params).toString()
    window.top.location.href = PARENT_SITE + RESULTS_PATH + (qs ? '?' + qs : '')
    return
  }
  router.push({ path: RESULTS_PATH, query: params })
}
